import { useMutation } from "@tanstack/react-query";
import { createSendFeedbackService, SendFeedbackPayload } from "../services/sendFeedbackService";

export const useSendFeedback = () => {
  const sendFeedbackService = createSendFeedbackService();

  return useMutation({
    mutationFn: (payload: SendFeedbackPayload) => sendFeedbackService.submitFeedback(payload),
  });
};